<div class="row justify-content-md-center">
  @if ((session$ | async) === 'invalid') {
    <div class="alert alert-warning col-md-8 col-12 text-center" role="alert">
      @if (showIcon) {
        <div><i class="fas fa-times-circle"></i></div>
      }
      {{ 'MY_ACCOUNT_LOGIN.LOGGED_OUT' | translate }}
    </div>
  }
  @if ((account$ | async) === false) {
    <div class="alert alert-warning col-md-8 col-12 text-center" role="alert">
      @if (showIcon) {
        <div><i class="fas fa-times-circle"></i></div>
      }
      {{ 'ERRORS.LOGIN_ERROR' | translate: { phone: branding.cs_phone_number } }}
    </div>
  }
  @if ((verifyAccount$ | async) === 'invalid') {
    <div class="alert alert-warning col-md-8 col-12 text-center" role="alert" >
      @if (showIcon) {
        <div><i class="fas fa-times-circle 3x"></i></div>
      }
      {{ 'MY_ACCOUNT_LOGIN.ERROR_INFO' | translate }}
    </div>
  }
</div>